import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Link,
  Box,
  Grid,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Button,
  Typography,
} from "@material-ui/core";
import Navbar from "./Navbar";
import project1 from "../images/html-css-javascript-lg.jpg";
import project2 from "../images/html-css-and-javascript.png";
import project3 from "../images/wallet.png";
import project4 from "../images/mern-stack.jpg";


const useStyles = makeStyles({
  mainContainer: {
    background: "#233",
    height: "100%",
  },
  cardContainer: {
    maxWidth: 345,
    margin: "5rem auto",
  },
});

const Portfolio = () => {
  const classes = useStyles();

  return (
    <>
    <Box component="div" className={classes.mainContainer}>
      <Navbar />
      <Grid container justify="center">

       <Grid item xs={12} sm={8} md={6}>
          <Card className={classes.cardContainer}>
            <CardActionArea>
              <CardMedia
                component="img"
                alt="Project 1"
                height="140"
                image={project3}
              />
              <CardContent>
                <Typography gutterBottom variant="h5">
                  Wallet Tracker
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                Wallet Tracking App is created with a goal to track Income & Expenses. It allows a person to know the things on which he's spending and things which are bringing him income.
                Features : Voice Enabled, Saves Data To Local Storage, Realtime Graphical Updations.
                Created using : React, React Hooks, Material UI, Toastify, Speechly
                </Typography>
              </CardContent>
            </CardActionArea>
            <CardActions>
            <Link style = {{textDecoration : "none"}} href = "https://github.com/theankitrana/wallet-tracker"  target = "_blank">
              <Button size="small" color="primary">
                Github
              </Button>
             </Link>
              <Link style = {{textDecoration : "none"}} href = "https://wallettracker.netlify.app/"  target = "_blank" >
              <Button size="small" color="primary">
                Live Demo
              </Button>
              </Link>
            </CardActions>
          </Card>
        </Grid>

        {/* Project 1 */}
        <Grid item xs={12} sm={8} md={6}>
          <Card className={classes.cardContainer}>
            <CardActionArea>
              <CardMedia
                component="img"
                alt="Project 2"
                height="140"
                image={project1}
              />
              <CardContent>
                <Typography gutterBottom variant="h5">
                  RGB Color Visualising Game 
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                A color code is displayed on the screen and multiple options are provided with different colors.
                User has to select the color which matches with the given color code, various levels of difficulty were also introduced.
                Created using : JavaScript, HTML, CSS, Bootstrap.

                </Typography>
              </CardContent>
            </CardActionArea>
            <CardActions>
             
              <Link style = {{textDecoration : "none"}} href = "https://github.com/theankitrana/RGB-Color-Guessing-Game"  target = "_blank">
              <Button size="small" color="primary">
                Github
              </Button>
              </Link>
            </CardActions>
          </Card>
        </Grid>

        {/* Project 2 */}
        <Grid item xs={12} sm={8} md={6}>
          <Card className={classes.cardContainer}>
            <CardActionArea>
              <CardMedia
                component="img"
                alt="Project 3"
                height="140"
                image={project2}
              />
              <CardContent>
                <Typography gutterBottom variant="h5">
                  Tic Tac Toe Using AI Algorithm
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                “Tic Tac Toe”  a classical game recreated with a modern tech stack,
                consists of Playing against a Friend/Computer. When a person is playing against a computer, 
                then the AI Min-Max algorithm is used in the backend by the computer to get the next best possible move. 
                Created using : JavaScript, HTML, CSS, Bootstrap.
                </Typography>
              </CardContent>
            </CardActionArea>
            <CardActions>
              <Link style = {{textDecoration : "none"}} href = "https://github.com/theankitrana/tic-tac-toe-using-AI"  target = "_blank">
              <Button size="small" color="primary">
                Github
              </Button>
              </Link>
            </CardActions>
          </Card>
        </Grid>
        {/* Project 3 */}

       

        {/* Project 4 */}
        <Grid item xs={12} sm={8} md={6}>
          <Card className={classes.cardContainer}>
            <CardActionArea>
              <CardMedia
                component="img"
                alt="Project 4"
                height="140"
                image={project4}
              />
              <CardContent>
                <Typography gutterBottom variant="h5">
                  Github Jobs Portal
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Fetched job data from github jobs api and displayed it in an organized manner on screen.
                  The details which are displayed include Job Title, Name of Company and Location along with the Date Job was posted.
                  A user is also provided the link to apply for that job and a toogle button to display complete/less job description.
                  Pagination is also done and mannually checked if next page exists or not as api doesn't provide that information.
                  Created using : React, Material UI, CSS.
                </Typography>
              </CardContent>
            </CardActionArea>
            <CardActions>
            <Link style = {{textDecoration : "none"}} href = "https://github.com/theankitrana/GithubJobsPortal"  target = "_blank">
              <Button size="small" color="primary">
                Github
              </Button>
              </Link>
              <Link style = {{textDecoration : "none"}} href = "https://jobsfromgithub.netlify.app/"  target = "_blank">
              <Button size="small" color="primary">
                Live Demo
              </Button>
              </Link>
            </CardActions>
          </Card>
        </Grid>
        
      </Grid>
     
    </Box>
    </>
  );
};

export default Portfolio;
